import { Injectable, Type } from '@angular/core';
import {
  ApiQuery,
  BaseApiService,
} from '@kinet-open-network/client/core/api-client';
import {
  mapToModel,
  toModel,
} from '@kinet-open-network/client/shared/data-access/model';
import {
  IPaymentActionData,
  IPaymentBatchActionData,
  ITransferPaymentData,
  ITransferPaymentPreview,
  ITransferPaymentResult,
} from '@kinet-open-network/shared/data-access/model';
import { map } from 'rxjs';
import { Payment } from '../models/payment.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentsService extends BaseApiService<Payment> {
  override model: Type<Payment> = Payment;

  override get endpoint(): string {
    return '/invoicing/payments';
  }

  pair(paymentId: string) {
    return this.http
      .put<Payment>(`${this.endpoint}/${this.encodeId(paymentId)}/pair`, {})
      .pipe(mapToModel(Payment));
  }

  transfer(paymentId: string, data: ITransferPaymentData) {
    return this.http
      .post<
        ITransferPaymentResult<Payment>
      >(`${this.endpoint}/${this.encodeId(paymentId)}/transfer`, data)
      .pipe(
        map((result) => ({
          ...result,
          payment: toModel(result.payment, Payment),
        })),
      );
  }

  transferPreview(
    paymentId: string,
    data: Omit<ITransferPaymentData, 'moveBankAccount'>,
  ) {
    return this.http.get<ITransferPaymentPreview>(
      `${this.endpoint}/${this.encodeId(paymentId)}/transfer/preview`,
      {
        params: {
          customerId: data.customerId,
          ...(data.date ? { date: new Date(data.date).toISOString() } : {}),
        },
      },
    );
  }

  runAction(data: IPaymentActionData) {
    return this.http.post<void>(`${this.endpoint}/action`, data);
  }

  batchAction(data: IPaymentBatchActionData, query?: ApiQuery | null) {
    return this.http.post<{ total: number }>(
      `${this.endpoint}/batch-action`,
      data,
      {
        params: this.apiQueryToHttpParams(query),
      },
    );
  }
}
